import { render, staticRenderFns } from "./ViewUserRolesModal.vue?vue&type=template&id=0fabaf34&scoped=true&"
import script from "./ViewUserRolesModal.vue?vue&type=script&lang=js&"
export * from "./ViewUserRolesModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewUserRolesModal.vue?vue&type=style&index=0&id=0fabaf34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fabaf34",
  null
  
)

export default component.exports